<mat-card class="mat-card-inline-sm">
  <mat-card-content fxLayout="column">
    <div class="mat-card-content-label w-100" fxLayout="row" fxLayoutAlign="space-between center">
      <label><span *ngIf="connectTypeFilter" [ngStyle]="{ 'color': getIconColor(connectTypeFilter) }">{{ getConnectTypeTooltip(connectTypeFilter) }}</span><span *ngIf="!connectTypeFilter"> situCONNECTs</span></label>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
        <mat-icon
          class="link"
          matTooltip="Search by Customer Details" 
          (click)="searchCustomer = !searchCustomer;" 
          color="accent">search</mat-icon>
        <mat-icon [class.link]="connectTypeFilter !== 'draftsitulinkpanoramas'" 
          [class.disable-link]="connectTypeFilter === 'draftsitulinkpanoramas'" 
          matTooltip="Show {{getConnectTypeTooltip('draftsitulinkpanoramas')}}" 
          (click)="setConnectTypeFilter('draftsitulinkpanoramas'); loadRecipeEventSummaries()" 
          [style.color]="getIconColor('draftsitulinkpanoramas')">panorama</mat-icon>
        <mat-icon [class.link]="connectTypeFilter !== 'situlinkpanoramas'"
          [class.disable-link]="connectTypeFilter === 'situlinkpanoramas'"
          matTooltip="Show {{getConnectTypeTooltip('situlinkpanoramas')}}"
          (click)="setConnectTypeFilter('situlinkpanoramas'); loadRecipeEventSummaries()"
          [style.color]="getIconColor('situlinkpanoramas')">panorama</mat-icon>
        <mat-icon [class.link]="connectTypeFilter !== 'facade'"
          [class.disable-link]="connectTypeFilter === 'facade'"
          matTooltip="Show {{getConnectTypeTooltip('facade')}}"
          (click)="setConnectTypeFilter('facade'); loadRecipeEventSummaries()"
          [style.color]="getIconColor('facade')">image</mat-icon>
        <mat-icon *ngIf="isAdmin || isSituUser"
          class="link"
          matTooltip="Search by Requester" 
          (click)="searchSourceUser = !searchSourceUser;"
          color="accent">person</mat-icon>
      </div>
    </div>
    <!-- <div *ngIf="filter?.type && filter?.value" fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
      <small>{{ filter?.type }} filter: </small><small><span class="highlight">{{ filter?.value }}</span></small><mat-icon (click)="clearFilter()" class="font-14 link mini-icon">clear</mat-icon>
    </div> -->
    <ng-container *ngIf="searchCustomer">
      <mat-form-field class="accent">
        <mat-label>Filter By Customer Details</mat-label>
        <input (keyup.enter)="loadRecipeEventSummaries()" (keyup.esc)="searchTerm=''; loadRecipeEventSummaries()" matInput type="text" name="searchTerm" [(ngModel)]="searchTerm">
        <button mat-button *ngIf="searchTerm" color="accent" matSuffix mat-icon-button aria-label="Search" (click)="loadRecipeEventSummaries()">
            <mat-icon>search</mat-icon>
        </button>
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadRecipeEventSummaries()">
            <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="searchSourceUser">
      <mat-card class="contrast mat-card-inline-sm">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <mat-form-field>
            <input matInput type="text"
              [formControl]="searchUsersField"
              (keyup)="doUserFilter($event.target.value)"
              (keyup.esc)="$event.target.value=''; doUserFilter('')"
              placeholder="Filter users by email">
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <ng-container *ngFor="let item of filteredUsers; let i=index">
        <mat-card *ngIf="i < 9" class="contrast card-link mat-card-inline-sm" (click)="selectUser(item)" [class.banner-info]="item.selected">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
              <strong matTooltip="User" [innerHtml]="item.item | highlight: searchUsersField.value"></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>
    <ng-container *ngFor="let item of items">
      <situ-connect-config-list-card [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [item]="item"
        [viewSituConnectId]="viewSituConnectId"
        (selectedConnectItem)="select($event)">
      </situ-connect-config-list-card>
    </ng-container>
  </mat-card-content>
</mat-card>